import { render, staticRenderFns } from "./ProductProperty.vue?vue&type=template&id=2d677792&scoped=true"
import script from "./ProductProperty.vue?vue&type=script&lang=js"
export * from "./ProductProperty.vue?vue&type=script&lang=js"
import style0 from "./ProductProperty.vue?vue&type=style&index=0&id=2d677792&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d677792",
  null
  
)

export default component.exports